import React from 'react';
import { Button } from 'react-bootstrap';
import config from '../../config';

const GoogleLoginButton = () => {
  return (
    <Button
      variant="secondary"
      block
      onClick={() => {
        window.location.href = `${config.apiUrl}/oauth/google/login`;
      }}
    >
      <i className="fab fa-google" /> Google Login
    </Button>
  );
};

export default GoogleLoginButton;
